import Swiper, {Autoplay, Pagination, Navigation} from 'swiper';

const initSliders = () => {
  // BANNER slider
  const bannersSliders = document.querySelectorAll('.banners-slider__swiper');
  if (bannersSliders.length > 0) {
    bannersSliders.forEach(slider => {
      const slidesCount = parseInt(slider.dataset.slidesCount);

      const bannersSliderSwiper = new Swiper(slider, {
        modules: [Autoplay, Pagination],
        spaceBetween: 0,
        slidesPerView: 1,
        loop: slidesCount > 1,
        speed: 2300,
        autoplay: {
          delay: 3500,
          disableOnInteraction: true,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        preventClicks: false,
        preventClicksPropagation: false,
      });
    });
  }

  //PRODUCTS slider
  if (document.querySelector('.products-slider__swiper')) {
    new Swiper('.products-slider__swiper', {
      modules: [Autoplay, Pagination, Navigation],
      slidesPerView: 1,
      loop: true,
      speed: 2100,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: '.products-slider__nav--next',
        prevEl: '.products-slider__nav--prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          loopFillGroupWithBlank: true,
        },
        1024: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          loopFillGroupWithBlank: true,
          pagination: {
            el: ".products-slider__pagination",
            clickable: true,
          },
          navigation: false,
        }
      },
      preventClicks: false,
      preventClicksPropagation: false,
    });
  }

  const videosSliders = document.querySelectorAll('.videos-slider__swiper');
  if (videosSliders.length > 0) {
    videosSliders.forEach((slider) => {
      new Swiper(slider, {
        modules: [Autoplay, Pagination],
        slidesPerView: 'auto',
        speed: 800,
        spaceBetween: 16,
        loop: false,
        autoplay: {
          delay: 2300,
          disableOnInteraction: true,
        },
        breakpoints: {
          768: {
            spaceBetween: 24,
          },
          1280: {
            spaceBetween: 32,
          }
        },
        preventClicks: false,
        preventClicksPropagation: false,
      })
    });
  }

  const featuredPSSlider = document.querySelector('.featured-party-starters');
  if (featuredPSSlider) {
    new Swiper('.featured-party-starters__swiper', {
      modules: [Autoplay, Navigation],
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      speed: 2300,
      autoplay: {
        delay: 3500,
        disableOnInteraction: true,
      },
      preventClicks: false,
      preventClicksPropagation: false,
      breakpoints: {
        768: {
          navigation: {
            nextEl: '.featured-party-starters__nav--next',
            prevEl: '.featured-party-starters__nav--prev',
          },
        },
      },
    });
  }

  const contentSlider = document.querySelector('.content-slider');
  if (contentSlider) {

    const swiper = new Swiper('.content-slider__swiper', {
      modules: [Autoplay, Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: {
        el: ".content-slider__pagination",
        clickable: true,
      },
      loop: true,
      speed: 2300,
      autoplay: {
        delay: 3500,
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
      },
      preventClicks: false,
      preventClicksPropagation: false,
      navigation: {
        nextEl: '.content-slider__nav--next',
        prevEl: '.content-slider__nav--prev',
      },
    });

    const iframes = document.querySelectorAll('.content-slider__video-holder iframe');
    if (iframes.length) {
      iframes.forEach((iframe, index) => {
        const player = new Vimeo.Player(iframe);

        player.on('play', function () {
          swiper.autoplay.stop();
          console.log('swiper stop');
        });

        player.on('pause', function () {
          swiper.autoplay.start();
          console.log('swiper start');
        });
      });
    }
  }
};

export {initSliders};
